import { render, staticRenderFns } from "./CreateFreelancerForm.vue?vue&type=template&id=4e8a1b36&scoped=true&"
import script from "./CreateFreelancerForm.vue?vue&type=script&lang=js&"
export * from "./CreateFreelancerForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateFreelancerForm.vue?vue&type=style&index=0&id=4e8a1b36&prod&lang=css&"
import style1 from "./CreateFreelancerForm.vue?vue&type=style&index=1&id=4e8a1b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a1b36",
  null
  
)

export default component.exports